var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrange20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833496 6.66536C0.833496 6.20513 1.20659 5.83203 1.66683 5.83203H18.3335C18.7937 5.83203 19.1668 6.20513 19.1668 6.66536C19.1668 7.1256 18.7937 7.4987 18.3335 7.4987H1.66683C1.20659 7.4987 0.833496 7.1256 0.833496 6.66536ZM0.833496 13.332C0.833496 12.8718 1.20659 12.4987 1.66683 12.4987H18.3335C18.7937 12.4987 19.1668 12.8718 19.1668 13.332C19.1668 13.7923 18.7937 14.1654 18.3335 14.1654H1.66683C1.20659 14.1654 0.833496 13.7923 0.833496 13.332Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrange20);
export default __webpack_public_path__ + "static/media/arrange-20.7f631fdf7876ecd9cfed3d6ace4bf52e.svg";
export { ForwardRef as ReactComponent };